<div [ngStyle]="{'background-color':_cookieInputs.backroundColor}" class="cookie-container">
    <!--<div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
        <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
    </div>-->
    <div *ngIf="isFirstCookieWindowDisplayed" class="cookie-first">
        <div class="title">
            <h3>{{cookieTranslationConfig.useOfCookies}}</h3>
        </div>
        <div class="text">
            <span
                >{{cookieTranslationConfig.cookieFunctionText}}
                <a href="{{ _cookieInputs.privacyPolicyUrl }}">{{cookieTranslationConfig.privacyPolicyLink}}</a>
            </span>
            <br />
        </div>

        <div class="button-container">
            <div class="button">
                <button [ngStyle]="{'background-color':_cookieInputs.buttonColor,'color':_cookieInputs.buttonTextColor}" (click)="changeCookieDisplayedWindow()">{{cookieTranslationConfig.cookieSettingsButton}}</button>
                <button [ngStyle]="{'background-color':_cookieInputs.buttonColor, 'color':_cookieInputs.buttonTextColor}" (click)="acceptWebsiteCookies()">{{cookieTranslationConfig.websiteCookiesAccepted}}</button>
            </div>
        </div>
    </div>
    <div [ngStyle]="{'background-color':_cookieInputs.backroundColor}" *ngIf="!isFirstCookieWindowDisplayed" class="cookie-second">
        <div class="cookie-settings-text">
            <div class="title">
                <h3>{{cookieTranslationConfig.cookieSettings}}</h3>
            </div>
            <div class="text">
                <span
                    >{{cookieTranslationConfig.nameOfTheSite}}
                    <a routerLink="/">{{cookieTranslationConfig.landingPageLinkOfTheSite}}</a>
                    {{cookieTranslationConfig.cookieConfigText}}</span
                ><br />
                <span>{{cookieTranslationConfig.reasonOdcookies}} </span>
                <ul>
                    <li>{{cookieTranslationConfig.functionOfWebsite}}</li>
                    <li>{{cookieTranslationConfig.fixOfFailures}}</li>
                    <li>{{cookieTranslationConfig.statistics}}</li>
                    <li>{{cookieTranslationConfig.lightweight}}</li>
                    <li>{{cookieTranslationConfig.offers}}</li>
                </ul>
                <span> {{cookieTranslationConfig.importantForUs}}</span><br />
                <span> {{cookieTranslationConfig.cookieCategories}}</span>
                <ul>
                    <li>{{cookieTranslationConfig.neededCookies}}</li>
                    <li>{{cookieTranslationConfig.preferenceCookies}}</li>
                    <li>{{cookieTranslationConfig.statisticCookies}}</li>
                    <li>{{cookieTranslationConfig.marketingCookies}}</li>
                </ul>

                <span> {{cookieTranslationConfig.rights}} </span><br />

                <span>
                    {{cookieTranslationConfig.moreInformation}}
                    <a href="{{ _cookieInputs.privacyPolicyUrl }}"> {{cookieTranslationConfig.privacyPolicyLink}}</a></span
                ><br />
            </div>
        </div>
        <div class="button-second-container">
            <div class="button">
                <button [ngStyle]="{'background-color':_cookieInputs.buttonColor,'color':_cookieInputs.buttonTextColor}" (click)="acceptAll()">   {{cookieTranslationConfig.allAccepted}}</button>
            </div>
        </div>
        <div class="cookie-settings-container">
            <div class="cookie-settings">
                <div class="title">
                    <h3>{{cookieTranslationConfig.cookieSettingsOption}}</h3>
                </div>
                <div class="cookie-set-up-container">
                    <div class="cookie-set-up">
                        <div class="setting-part">
                            <div class="setting-text">{{cookieTranslationConfig.websiteCookies}}</div>
                            <span [ngStyle]="{'color':_cookieInputs.buttonColor}">{{cookieTranslationConfig.active}}</span>
                        </div>
                        <div *ngIf="hasAnyOtherSettings" class="setting-part">
                            <div class="setting-text">{{cookieTranslationConfig.settingsCookies}}</div>
                            <mat-checkbox
                                (click)="onChangeSettings()"
                                [ngModel]="acceptSettings"
                                id="active"
                                class="form-control"
                                type="checkbox"
                                required
                            ></mat-checkbox>
                        </div>
                        <div *ngIf="hasGoogleAnalytics" class="setting-part">
                            <div class="setting-text">{{cookieTranslationConfig.websiteStatisticCookies}}</div>
                            <mat-checkbox
                                (click)="onChangeAnalytics()"
                                [ngModel]="acceptGoogleAnalytics"
                                id="active"
                                class="form-control"
                                type="checkbox"
                                required
                            ></mat-checkbox>
                        </div>
                        <div *ngIf="hasGoogleAds" class="setting-part">
                            <div class="setting-text">{{cookieTranslationConfig.websiteMarketingCookies}}</div>
                            <mat-checkbox
                                (click)="onChangeGoogleAds()"
                                [ngModel]="acceptGoogleAds"
                                id="active"
                                class="form-control"
                                type="checkbox"
                                required
                            ></mat-checkbox>
                        </div>
                    </div>
                    <div class="button-third-container">
                        <div class="button">
                            <button [ngStyle]="{'background-color':_cookieInputs.buttonColor,'color':_cookieInputs.buttonTextColor}" (click)="rejectAll()">{{cookieTranslationConfig.dismiss}}</button>
                            <button [ngStyle]="{'background-color':_cookieInputs.buttonColor, 'color':_cookieInputs.buttonTextColor}" (click)="savePreferences()">{{cookieTranslationConfig.settingsAccepted}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
